import { type DevScenarioEntry, devScenarioEntry, mockApiError } from '@arya/shared/msw-cloudflare';

export const PROJECT_NOT_LISTED: DevScenarioEntry = devScenarioEntry(
  {
    name: 'project-404',
    group: 'Project detail',
    title: 'No longer listed',
    description: 'The project detail answers 404: "This project is no longer listed".',
    screen: '/market/projects/2',
  },
  { method: 'GET', path: '/api/market/projects/:projectId' },
  () => mockApiError(404, 'Project not found')
);
